import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import pipe from "ramda/src/pipe";
import {produce} from 'immer';


export const createSelectors = (store) => {
  store.use = {}
  for (let k of Object.keys(store.getState())) {
    ; (store.use)[k] = () => store((s) => s[k])
  }
  return store
};

export const createBase = (baseStateAndActions, persistOptions) => {
  return create()(
    // devtools(
      persist(
        immer(baseStateAndActions),
        persistOptions
      )
    // ),
  )
}

// logger 中间件
const log = (config) => (set, get, api) =>
  config(
      (...args) => {
          console.group('state update');
          console.log(`%c  prev state %c %O`, 'color: #666', 'color: #000', get());
          console.log(`%c  action %c %O`,'color: #45e', 'color: #000', args);
          set(...args);
          console.log(`%c  current state %c %O`,'color: #4e5', 'color: #000', get());
          console.groupEnd();
      },
      get,
      api
  );

const withImmer = config => (set, get, api) =>
  config((fn) => set(produce(fn)), get, api);
const withPersist = config => persist(config, { name: 'some-store' });

// 使用immer+persist+logger+devtools中间件
export const createStore = pipe(withImmer, withPersist, log, devtools, create);

// 使用immer+logger中间件
export const createStoreWithImmerAndLogger = pipe(log, withImmer, create);

const withPersistForName = name => config => persist(config, { name , storage: createJSONStorage(() => localStorage)});
export const createStoreWithName = name => pipe(withImmer, withPersistForName(name), log, devtools, create);

// 可指定Persist的storage名称和持久化黑名单
const withPersistForNameAndBlacklist = (name,blacklist) =>
      config => persist(config,
          {
              name ,
              storage: createJSONStorage(() => localStorage),
              partialize: state => {
                  const result = {...state};
                  blacklist.forEach(item => delete result[item]);
                  return result;
              },
          }
      );
export const createStoreWithStorageNameAndBlacklist = (name, blacklist) =>
  pipe(withImmer, withPersistForNameAndBlacklist(name, blacklist), log, devtools, create);

